import { IMAGE_CONFIG, IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { EnvironmentProviders, Inject, makeEnvironmentProviders } from '@angular/core';
import { DOMAIN_NUMBER_STR } from '@bcf-v2-platforms/platform-worker/common';
import { BCF_PRODUCTION_MODE, BCF_RELEASE_VERSION } from '../app/token';
import { IMG_WEB_CONFIG } from './token';
import { ImgWebConfig } from './types';

// Angular's default srcset ends at 3840. Fill images request every breakpoint from 640 up.
const imgWebSrcsetBreakpoints: number[] = [16, 32, 48, 64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920];

export function provideImgWebLoader(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: IMAGE_CONFIG,
      useValue: {
        breakpoints: imgWebSrcsetBreakpoints
      }
    },
    {
      provide: IMAGE_LOADER,
      useFactory:
        (imgWebConfig: ImgWebConfig, isProductionMode: boolean, domainNumberStr: string, releaseVersion: string) =>
        (config: ImageLoaderConfig) => {
          const hostUrl: string = isProductionMode ? imgWebConfig.hostUrlProd : imgWebConfig.hostUrlDev;
          const widthQuery: string = config.width ? `&width=${Math.round(config.width)}` : '';
          const src: string = `${hostUrl}get-webp/?url=${config.src}&v=${releaseVersion}${widthQuery}`;
          return src.replace('{apiVersion}', domainNumberStr);
        },
      deps: [
        [new Inject(IMG_WEB_CONFIG)],
        [new Inject(BCF_PRODUCTION_MODE)],
        [new Inject(DOMAIN_NUMBER_STR)],
        [new Inject(BCF_RELEASE_VERSION)]
      ]
    }
  ]);
}
